import React, { Component } from "react";
import axios from "axios";
import ProgressCircleWrapper from "./ProgressCircleWrapper";
import { Redirect } from "react-router-dom";
import logo_correios_menu from "../images/home-run.png";
import emojis from "../images/emojis.png";
import "../style/programadaMenu.css";

import { transactionID } from "../services/helpers";
import { getAccountDetailsRequest } from "../services/requests/getAccountDetails.request";

import { Link } from "react-router-dom";
import Loading from "./Loading/Loading";

class Menu extends Component {
  constructor() {
    super();
    let localStorageClientInfo = localStorage.getItem("clientInfo");

    this.state = {
      redirect: false,
      currBalance: 0,
      phone: 0,
      details: [],
      valorProgress: 0,
      showProgram: false,
      days: 0,
      dateFull: "",
      pathname: window.location.pathname.split("/")[1],
      isIntelligentControl:
        localStorageClientInfo !== null
          ? JSON.parse(localStorage.getItem("clientInfo")).isIntelligentControl
          : "",
    };
  }

  toggleMenu() {
    let body = document.querySelector("body");
    body.classList.toggle("menu-collapse");
  }

  formatReal(int) {
    var tmp = int + "";
    tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
    if (tmp.length > 6) tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");

    return `R$${tmp}`;
  }

  formartDate = (date) => {
    return (
      date.split(" ")[0].split("-")[2] +
      "/" +
      date.split(" ")[0].split("-")[1] +
      "/" +
      date.split(" ")[0].split("-")[0]
    );
  };

  countDays = (date) => {
    var today = new Date();
    var cmas = new Date(date);
    // if (today.getMonth()==11 && today.getDate()>25)
    // {
    // cmas.setFullYear(cmas.getFullYear()+1);
    // }
    var one_day = 1000 * 60 * 60 * 24;
    this.setState({
      days: Math.ceil((cmas.getTime() - today.getTime()) / one_day),
    });
  };

  logout = (e) => {
    e.preventDefault();
    localStorage.removeItem("clientInfo");
    localStorage.removeItem("BundleInfo");
    localStorage.removeItem("infoDetails");
    localStorage.removeItem("@pix-data");
    localStorage.removeItem("@pix-data-recharge");
    localStorage.removeItem("homeHistory");
    localStorage.removeItem("accountDetails");
    sessionStorage.removeItem("hasLoadedAccountDetails");
    this.setState({ redirect: true });
  };

  AccountDetails = async () => {
    try {
      if (sessionStorage.getItem("hasLoadedAccountDetails") === "true") {
        const accountDetails = JSON.parse(
          localStorage.getItem("accountDetails")
        );
        return this.setState(accountDetails);
      }

      this.setState({
        loading: true,
      });

      const clientInfo = JSON.parse(localStorage.getItem("clientInfo"));
      const accountDetails = await getAccountDetailsRequest({
        msisdn: clientInfo?.number,
        accessToken: clientInfo?.accessToken,
      });

      if (!!accountDetails) {
        this.setState(accountDetails);
        localStorage.setItem("accountDetails", JSON.stringify(accountDetails));
        sessionStorage.setItem("hasLoadedAccountDetails", "true");
      }
    } catch (error) {
      console.log({ error });
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  queryProgram = () => {
    axios
      .post(
        "https://www.pagtel.com.br/Hub360Correios/v2/queryProgram",
        {
          transactionId: transactionID("AAI"),
          msisdn: JSON.parse(localStorage.getItem("clientInfo")).number,
        },
        {
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(localStorage.getItem("clientInfo")).accessToken,
          },
        }
      )
      .then((response) => {
        switch (response.data.code) {
          case "P00":
            this.setState({
              showProgram: true,
              dateFull: this.formartDate(
                response.data.program[0].nextRechargeDay
              ),
            });
            this.countDays(response.data.program[0].nextRechargeDay);
            break;
          case "P01":
            this.setState({ showProgram: false });
            break;
          default:
            break;
        }
      });
  };

  componentDidMount = () => {
    this.AccountDetails();
    this.queryProgram();
  };

  render() {
    if (this.state.redirect) {
      return (
        <Redirect
          to={{
            pathname: "/home",
          }}
        />
      );
    }

    let { isIntelligentControl } = this.state;

    return (
      <div className="menu-aside">
        {this.state.loading === true && <Loading loading={1} />}
        <div className="menu-top">
          <Link to="/home">
            <img src={logo_correios_menu} alt="logo" />
          </Link>
          <i
            className="menu-icon"
            onClick={() => {
              this.toggleMenu();
            }}
          ></i>
        </div>
        <div className="menu-perfil">
          <p className="menu-phone">{this.state?.phone}</p>

          <span className="menu-balance">
            SALDO:{" "}
            {parseFloat(this.state?.currBalance || 0).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })}
          </span>
        </div>

        {this.state.showProgram ? (
          <div className="menu--program">
            <h3>
              {!isIntelligentControl
                ? "Recarga Programada"
                : "Controle Inteligente"}
            </h3>
            <p className="menu--program-date">
              Próxima recarga: {this.state.dateFull}
            </p>
            <div className="menu--program-graph">
              <ProgressCircleWrapper
                svgWidth={140}
                arcWidth={9}
                progressPercentage={((30 - this.state.days) / 30) * 100}
              />
              <div className="left-days">{this.state.days}</div>
              <div className="left-days-title">
                {this.state.days !== 1 ? "Dias" : "Dia"} para a recarga
              </div>
            </div>
            <a href="minhaProgramada">
              <div className="program--btn-detalhe">Detalhes</div>
            </a>
          </div>
        ) : (
          <div className="noProgram">
            <h3>Recarga Programada</h3>
            <p>
              Você não possui outras recargas agendada, deseja programar Uma
              nova recarga?
            </p>
            <img src={emojis} />
            <a href="Programada">
              <div className="btn-program">Programar nova Recarga</div>
            </a>
          </div>
        )}

        {/* <div className="menu--btn-recharge">
                    Recarga Programada
                </div> */}

        <ul className="menu--list-functions">
          <li className="small-logo-menu-collapse">
            <a href="home">
              <img
                src={require("../images/logo-correios-menu.svg")}
                alt="logo"
              />
            </a>
          </li>
          <li>
            <a
              href={
                !isIntelligentControl ? "Recarga" : "RecargaControleInteligente"
              }
              onClick={() => {
                localStorage.setItem("@pix-data-recharge", JSON.stringify(""));
              }}
            >
              <i className="menu-icon-list recharge"></i>
              <p>Recarga</p>
            </a>
          </li>
          <li>
            <a
              href={
                !isIntelligentControl
                  ? "Recarga#pacote-adicional"
                  : "/PacoteAdicional#adicional"
              }
              onClick={() => {
                localStorage.setItem("@pix-data-recharge", JSON.stringify(""));
              }}
            >
              <i className="menu-icon-list recharge"></i>
              <p>Pacote adicional</p>
            </a>
          </li>
          <li>
            <a href="carteira">
              <i className="menu-icon-list wallet"></i>
              <p>Minha Carteira</p>
            </a>
          </li>
          {/* <li>
                        <a href="#">
                            <i className="menu-icon-list consumption"></i>
                            <p>Meu Consumo</p>
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <i className="menu-icon-list history"></i>
                            <p>Histórico</p>
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <i className="menu-icon-list portability"></i>
                            <p>Portabilidade</p>
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <i className="menu-icon-list buyChip"></i>
                            <p>Compra de Chip</p>
                        </a>
                    </li> */}

          <li>
            <a href="configuracoes">
              <i className="menu-icon-list settings"></i>
              <p>Configurações</p>
            </a>
          </li>

          <li className="out-btn">
            <a onClick={this.logout} href="#">
              <i className="menu-icon-list out"></i>
              <p>Sair</p>
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

export default Menu; // Don’t forget to use export default!
